// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"e3215796","109":"41fefa25","153":"ded42a52","396":"021c786f","444":"5afce3b0","453":"8894421c"}[chunkId] + ".chunk.js";
};